<template>
  <aside class="left-aside">
    <BloxupLogo />
    <div class="menu">
      <ul>
        <MenuItem
          v-for="item in menuItems"
          :key="item.value"
          :label="item.name"
          :icon="item.icon"
          :to="item.to"
          :active="$route.path.startsWith(`/${item.value}`)"
        />
      </ul>
    </div>
    <div class="footer">
      <div class="online-players">
        <span class="count-online-players" v-if="!globalConfig.loading">{{
          globalConfig.data.onlineUsersCount?.toLocaleString()
        }}</span>
        <div class="wrapper">
          <Ping />
          <span>{{ $t("global.online_players") }}</span>
        </div>
        <span class="ellipse"></span>
      </div>
      <div class="settings-wrapper">
        <div>
          <!-- <Setting :color="'rgb(255 255 255 / 60%)'" /> -->
          <a
            href="https://discord.gg/gXPXEYsk2M"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Discord />
          </a>
          <!-- <router-link to="/settings">
          </router-link> -->
        </div>
        <div>
          <router-link to="/support">
            <Support :color="'rgb(255 255 255 / 60%)'" />
          </router-link>
        </div>
      </div>
    </div>
  </aside>
</template>

<script lang="ts">
import { defineComponent, shallowRef } from "vue"
import MenuItem from "@/components/layout/AsideMenuItem.vue"
import {
  CoinFlip,
  WheelOfFortune,
  Upgrader,
  Giveaways,
  History,
  Ping,
  Support,
} from "@/components/icons/index"
import { CasinoGameSlug, GameSlug } from "@/services/enums"
import { AsyncState, Configs } from "@/store/types"
import Discord from "../icons/Discord.vue"
import BloxupLogo from "../BloxupLogo.vue"
export default defineComponent({
  name: "LeftAside",
  props: {},
  data() {
    return {
      menuItems: [
        {
          name: "layout.aside.coin_flip",
          value: CasinoGameSlug.CoinFlip,
          icon: shallowRef(CoinFlip),
          to: {
            name: "coin-flip",
            params: { gameSlug: GameSlug.MM2 },
          },
        },
        {
          name: "layout.aside.wheel_of_fortune",
          value: CasinoGameSlug.WheelOfFortune,
          icon: shallowRef(WheelOfFortune),
          to: {
            name: "wheel-of-fortune.rounds",
            params: { gameSlug: GameSlug.MM2 },
          },
        },
        {
          name: "layout.aside.upgrader",
          value: CasinoGameSlug.Upgrader,
          icon: shallowRef(Upgrader),
          to: {
            name: "upgrader",
            params: { gameSlug: GameSlug.MM2 },
          },
        },
        {
          name: "layout.aside.giveaways",
          value: "giveaways",
          icon: shallowRef(Giveaways),
          to: { name: "giveaways" },
        },
        {
          name: "layout.aside.game_history",
          value: "game-history",
          icon: shallowRef(History),
          to: { name: "game-history" },
        },
      ],
    }
  },
  components: { MenuItem, Ping, Discord, Support, BloxupLogo },
  computed: {
    globalConfig(): AsyncState<Configs> {
      return this.$store.getters["global/data"]
    },
  },
})
</script>
<style scoped lang="scss">
.left-aside {
  // position: fixed;
  // display: flex;
  // flex-direction: column;
  // gap: 38px;
  // align-items: center;
  // padding: 26px 32px 32px;
  // width: calc(var(--left-aside-width) - 64px);
  // height: 768px;
  // background: var(--black-gradient);

  // box-shadow: 0px 1px 1px 0px #090d1466;

  // color: #ffffff;

  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 38px;
  align-items: center;
  padding: 26px 32px 32px;
  width: calc(var(--left-aside-width));
  height: 100%;
  box-sizing: border-box;
  background: var(--black-gradient);
  box-shadow: 0px 1px 1px 0px rgba(9, 13, 20, 0.4);
  color: #ffffff;
  z-index: 11;

  .menu {
    align-self: self-start;
    width: 100%;
  }

  .footer {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: auto;

    .online-players {
      overflow: hidden;
      padding: 12px;
      width: 126px;
      height: 52px;
      background: rgba(255, 255, 255, 0.04);
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      position: relative;

      .count-online-players {
        z-index: 1;
        width: 80px;
        height: 24px;
        font-family: "Druk Text Wide Cyr";
        font-style: normal;
        font-weight: 900;
        font-size: 20px;
        line-height: 24px;
        color: #ffffff;
      }
      .wrapper {
        z-index: 1;
        display: flex;
        align-items: center;
        gap: 8px;
        width: 113px;
        height: 20px;
        font-family: Montserrat;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.4px;
        text-align: center;
      }

      .ellipse {
        z-index: 0;
        position: absolute;
        width: 100px;
        height: 100px;
        left: 60px;
        top: 30px;
        background: linear-gradient(
          135deg,
          #00ffaa 0%,
          #4579f5 51.65%,
          #9c42f5 99.83%
        );
        filter: blur(22px);
      }
    }

    .settings-wrapper {
      display: flex;
      gap: 8px;

      div {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        width: 71px;
        height: 44px;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 12px;
      }
      // .settings {}
    }
  }
}
</style>
